/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const skeletonConstants = {
  loaderBackgroundColor: '#F6F7F8',
  loaderBorderRadius: '6px',
  backgroundColor: '#e3e3e3',
  foregroundColor: '#cccccc',
};
